import { FC, ReactNode } from 'react'
import s from './StepperStep.module.sass'
import { Text } from '@shared/ui/Typography/Text'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'

type StepState = 'inactive' | 'progress' | 'completed'

export interface StepperStepProps {
  index?: number
  title: ReactNode
  state?: StepState
  children?: ReactNode
}

//не имеет смысла вне <Stepper> и код степпера стоит держать в голове, делая изменения здесь
export const StepperStep: FC<StepperStepProps> = ({ index, title, state }) => {
  const { isMobile } = useClientResponsive()

  return (
    <Text sizes={'S'} className={`${s['step-label']} ${s[state]}`}>
      {(isMobile && state === 'completed') || state === 'inactive' ? (
        index
      ) : (
        <>
          {index}. {title}
        </>
      )}
    </Text>
  )
}
